import { format, parseISO } from 'date-fns'
import Vue from 'vue'

Vue.filter('date', (value) => {
  value = parseISO(value)
  if (!(value instanceof Date && !isNaN(value))) return ''
  return format(value, 'dd.MM.yyyy')
})
